<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">

		<van-cell-group>
			<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
				<span class="rowlabel"></span>审核状态
			</div>
			<div style="padding: 20px; font-size: 14px; position: relative;">
				<div style="font-weight: bold;">
					我的报名
				</div>
				<div style="padding-top: 10px; color: #888;">
					提交时间：{{stuForm.cdate}}
				</div>

				<div style="position: absolute; top: 10px; right: 30px; width: 60px;">
					<img v-if="stuForm.status==0" src="//aiwx.org.cn/static/icon/static/sp_normal.png" style="width: 100%;">
					<img v-if="stuForm.status==1" src="//aiwx.org.cn/static/icon/static/sp_over.png" style="width: 100%;">
					<img v-if="stuForm.status==-1" src="//aiwx.org.cn/static/icon/static/sp_fail.png" style="width: 100%;">
					
				</div>
				<div style="font-size: 12px; color: orangered;" v-if="stuForm.status==-1">
					{{stuForm.sp_word}}
				</div>

				<div v-if="stuForm.status==-1" style="text-align:right;padding-top:10px">
					<el-button @click="goResult" type="danger" size="small" icon="el-icon-collection" style="margin-top: 0px;">修改报名信息<i class="el-icon-right"></i></el-button>

				</div>
			</div>

			<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
				<span class="rowlabel"></span>报名信息
			</div>

			<van-field readonly v-model="stuForm.stu_name" label="考生姓名"  label-width="110px"/>
			<!-- <van-field readonly v-model="stuForm.exam_num" v-if="stuForm.exam_num" label="准考证号"  label-width="110px"/> -->
			<van-field readonly v-model="stuForm.phone" label="手机号"  label-width="110px"/>
			<van-field readonly :value="stuForm.identity_card" label="身份证号"  label-width="110px"/>
			<van-field readonly v-model="stuForm.birthday" label="出生年月"  label-width="110px"/>
			<van-field readonly :value="stuForm.gender==1?'男':'女'" label="性别"  label-width="110px"/>
			<van-field readonly v-model="stuForm.minzu" label="民族"  label-width="110px"/>
			<van-field readonly v-model="stuForm.hkxz" label="户口性质"  label-width="110px"/>
			<van-field readonly v-model="stuForm.hkszd" label="户口所在"  label-width="110px"/>
			<van-field readonly v-model="stuForm.graduate_sch_city" label="所在地区"  label-width="110px"/>
			<van-field readonly v-model="stuForm.graduate_schname" label="所在学校"  label-width="110px"/>
			<van-field readonly v-model="stuForm.ly_type" label="考生来源" label-width="110px">
				<template #input>
					<span v-if="stuForm.ly_type==1">应届生（本年度6月份毕业）</span>
					<span v-if="stuForm.ly_type==2">往届生（上一年度毕业生）</span>
					<span v-if="stuForm.ly_type==3">在校生（初一年级）</span>
					<span v-if="stuForm.ly_type==4">在校生（小学五年级）</span>
					
				</template>
			</van-field>
			<van-field readonly v-model="stuForm.jtzz" label="收件地址"  label-width="110px"/>
			<van-field readonly v-model="stuForm.jhr1name" label="收件人"  label-width="110px"/>
			<van-field readonly v-model="stuForm.major.title" label="报考专业名称" label-width="110px" />
			<van-field readonly v-model="stuForm.major.item_desc" label="学制" label-width="110px" />
			<van-field readonly v-model="stuForm.graduate_schname" label="户口簿/身份证" label-width="110px">
				<template #input>
					<div  style="width: 50%; margin: 0 auto;">
						<img :src="stuForm.otherjson.identity_card1" style="width: 100%;" />
					</div>
					
				</template>
			</van-field>
			<van-field readonly v-model="stuForm.graduate_schname" label="证件照" label-width="110px" >
				<template #input>
					<div  style="width: 50%; margin: 0 auto;">
						<img :src="stuForm.otherjson.dzzj" style="width: 100%;" />
					</div>
					
				</template>
			</van-field>
			<van-field readonly v-model="stuForm.graduate_schname" label="学籍证明" label-width="110px" >
				<template #input>
					<div  style="width: 50%; margin: 0 auto;">
						<img :src="stuForm.otherjson.score" style="width: 100%;" />
					</div>
					
				</template>
			</van-field>
			<div style="height: 50px;">
				
			</div>
		</van-cell-group>
		

	</div>
</template>

<script>
	import {
		Dialog,
		Toast,
		Uploader
	} from 'vant';
	export default {
		data() {
			return {

				stuForm: {
					ly_type: "",
					stu_name: "",
					archive: "",
					identity_card: "",
					phone: "",
					gender: "",
					exam_score: "",
					graduate_sch_city: "",
					graduate_schid: -1,
					graduate_schname: "",
					graduate_schname2: "",
					graduate_dist_code: "",
					major_id: "",
					major_id2: '',
					major_id3: '',
					major_name: "",
					major_name2: "",
					major_name3: "",
					volunteer: '',
					volunteerTxt: "",
					oldname: '',
					exam_num: '',
					remark: "",
					jhr1name: "",
					jhr1phone: "",
					jhr2name: "",
					jhr2phone: "",
					minzu: "",
					zzmm: "",
					jiguan: "",
					hkszd: "",
					hkszdpcs: "",
					hkxz: "",
					jzdtype: "",
					jtzz: "",


				},

			}
		},
		mounted() {
			$(".page").height($(window).height())
			document.title = "报名详情"
			this.pmid = this.$route.query.pmid
			this.openid = this.$route.query.openid
			if (!this.openid) {
				Dialog.alert({
					title: '网络错误',
					message: '未获取到微信授权用户信息，请重新扫码！',
					theme: 'round-button',
				}).then(() => {
					// on close
				});
			} else {
				window.pmid = this.pmid
				this.getStudents()

			}





		},
		methods: {

			getStudents() {

				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {
					if (res.data) {


						res.data.otherjson = JSON.parse(res.data.otherjson)
						this.stuForm = res.data

					}else{
						Dialog.alert({
							title: '提示',
							message: '未找到报名信息！',
							theme: 'round-button',
						}).then(() => {
							// on close
						});
					}



				})
			},
			goResult(){
				this.$router.push("/bk?pmid="+window.pmid+"&openid="+this.$route.query.openid)
			}

		},
	}
</script>
<style type="text/css" scoped="scoped">
	.rowlabel {
		display: inline-block;
		width: 6px;
		border-radius: 3px;
		height: 14px;
		float: left;
		background: #1283ff;
		vertical-align: middle;
		transform: translateY(2px);
		margin-right: 5px;
	}
</style>
